module.exports = __webpack_public_path__ + "img/path-header-line.19d7fa69.png";